import {Person} from './person';
import {Group} from './group';
import {Role} from './role';

export enum RoleName { IECIT = 'IECIT', IECCustomerService = 'IECCustomerService', IECCredAnalyst = 'IECCredAnalyst', IECApplicationEngineer = 'IECApplicationEngineer', IECReadOnly = 'IECReadOnly', IECRSM = 'IECRSM', LSBCS = 'LSBCS', PartsEngineer = 'PartsEngineer', IECPaperPilotCreator = 'IECPaperPilotCreator' };

export class PersonLogin {

  person!: Person;
  googleId!: string;
  token!: string;
  internalId!: string;
  groups!: Group[];
  roles!: Role[];

}

